<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener('DOMContentLoaded', function() {
    const headings = document.querySelectorAll('.blog-title');

    headings.forEach((heading) => {
        const link = heading.querySelector('a');
        let textContent;

        if (link) {
            textContent = link.innerHTML.trim().split(' ');
            if (textContent.length > 6) {
                link.innerHTML = textContent.slice(0, 6).join(' ') + '...';
            }
        } else {
            textContent = heading.textContent.trim().split(' ');
            if (textContent.length > 6) {
                heading.textContent = textContent.slice(0, 6).join(' ') + '...';
            }
        }
    });
});
